import React, { useState, useEffect } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import { useParams } from "react-router-dom";
import Schedule from "../../commonpage/Schedule";
import Loader from "../../utils/Loader";
import ModalManager from "../../Modals/ModalManager";
import { handleItemsPerPageChange, handlePageChange } from "../../utils/PaginationUtilities";

export default function ViewSchedule({ title }) {
    const [schedules, setSchedules] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalData, setTotalData] = useState(0);
    const dispatch = useDispatch();
    const { batchId } = useParams();
    const loading = useSelector((state) => state.loader.loading);
    const isOpen = useSelector((state) => state.modal.isOpen);

    const fetchSchedules = async () => {
        try {
            dispatch(showLoader());
            const res = await ApiServices.apiRequest("getSchedule", {
                batchId: batchId,
                ishide: false,
                limit: itemsPerPage,
                pageno: currentPage + 1
            });

            if (res.data.success) {
                setTotalData(res.data.total || 0);
                setTotalPages(Math.ceil(res.data.total / itemsPerPage));
                
                const activeSchedules = res.data.data.filter(
                    (schedule) => schedule?.status === true
                );

                setSchedules(activeSchedules);
                console.log("Active schedule data in students is:", activeSchedules);
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error(err?.message || "Something went wrong");
        } finally {
            dispatch(hideLoader());
        }
    };

    useEffect(() => {
        if (!isOpen) {
            fetchSchedules();
        }
    }, [isOpen, currentPage, itemsPerPage, batchId]);

    return (
        <div className="container">
            <div className="page-inner">
                {loading && !isOpen ? (
                    <Loader />
                ) : (
                    <>
                        <div className="d-flex justify-content-between align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                            <div className="col-md">
                                <h3 className="fw-bold mt-3">{title}</h3>
                            </div>
                        </div>
                        <hr />
                        <Schedule
                            schedules={schedules}
                            totalData={totalData}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange(setCurrentPage)}
                            handleItemsPerPageChange={handleItemsPerPageChange(setItemsPerPage, setCurrentPage)}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
